import { ReactComponent as Disappointed } from 'assets/icon/ic_disappointed_c.svg';
import { ReactComponent as Good } from 'assets/icon/ic_good_c.svg';
import { ReactComponent as Happy } from 'assets/icon/ic_happy_c.svg';
import { ReactComponent as Neutral } from 'assets/icon/ic_neutral_c.svg';
import { ReactComponent as Sad } from 'assets/icon/ic_sad_c.svg';
import { ReactComponent as Cloud } from 'assets/icon/ic_cloudy_c.svg';
import { ReactComponent as Rain } from 'assets/icon/ic_rainy_c.svg';
import { ReactComponent as Sun } from 'assets/icon/ic_sunny_c.svg';
import { ReactComponent as Thunder } from 'assets/icon/ic_thunder_c.svg';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { Col, Form, Input, Row } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { formRules } from 'constants/GlobalConfig';

type Props = {
    type: number;
    evaluationScaleMax?: number;
};

export const Explanation: React.FC<Props> = ({ type, evaluationScaleMax }) => {
    switch (type) {
        case 4 /** 顔マーク5段階 */:
            return (
                <Row gutter={[32, 32]} wrap>
                    <Col>
                        <Row gutter={[8, 8]} align='middle' justify='center' style={{ flexDirection: 'column' }}>
                            <Disappointed className='w-8 h-8' />
                            <Form.Item name={[0]} rules={[formRules.range({ max: 20 })]}>
                                <Input style={{ borderRadius: '0.5rem', width: '80px' }} placeholder='とても悪い' />
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col>
                        <Row gutter={[8, 8]} align='middle' justify='center' style={{ flexDirection: 'column' }}>
                            <Sad className='w-8 h-8' />
                            <Form.Item name={[1]} rules={[formRules.range({ max: 20 })]}>
                                <Input style={{ borderRadius: '0.5rem', width: '80px' }} placeholder='少し悪い' />
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col>
                        <Row gutter={[8, 8]} align='middle' justify='center' style={{ flexDirection: 'column' }}>
                            <Neutral className='w-8 h-8' />
                            <Form.Item name={[2]} rules={[formRules.range({ max: 20 })]}>
                                <Input style={{ borderRadius: '0.5rem', width: '80px' }} placeholder='普通' />
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col>
                        <Row gutter={[8, 8]} align='middle' justify='center' style={{ flexDirection: 'column' }}>
                            <Good className='w-8 h-8' />
                            <Form.Item name={[3]} rules={[formRules.range({ max: 20 })]}>
                                <Input style={{ borderRadius: '0.5rem', width: '80px' }} placeholder='少し良い' />
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col>
                        <Row gutter={[8, 8]} align='middle' justify='center' style={{ flexDirection: 'column' }}>
                            <Happy className='w-8 h-8' />
                            <Form.Item name={[4]} rules={[formRules.range({ max: 20 })]}>
                                <Input style={{ borderRadius: '0.5rem', width: '80px' }} placeholder='とても良い' />
                            </Form.Item>
                        </Row>
                    </Col>
                </Row>
            );
        case 6 /** 星マーク */:
            if (!evaluationScaleMax) return <></>;
            return (
                <Row gutter={[32, 32]}>
                    {[...Array(evaluationScaleMax)].map((_, index) => {
                        const scaleNum = index + 1;
                        return (
                            <Col key={`name-${scaleNum}`}>
                                <Row
                                    gutter={[8, 8]}
                                    align='middle'
                                    justify='center'
                                    style={{ flexDirection: 'column' }}>
                                    <div className='mx-auto font-bold text'>{scaleNum}</div>
                                    <FontAwesomeIcon
                                        icon={faStar as IconProp}
                                        size='2x'
                                        className='text-star-sm h-10 lg:text-star-md lg:h-12 text-lg-yellow'
                                    />
                                    <Form.Item name={[index]} rules={[formRules.range({ max: 20 })]}>
                                        <Input style={{ borderRadius: '0.5rem', width: '80px' }} placeholder={`${scaleNum}`} />
                                    </Form.Item>
                                </Row>
                            </Col>
                        );
                    })}
                </Row>
            );
        case 9 /** 天気マーク */:
            return (
                <Row gutter={[32, 32]}>
                    <Col>
                        <Row gutter={[8, 8]} align='middle' justify='center' style={{ flexDirection: 'column' }}>
                            <Thunder className='w-8 h-8' />
                            <Form.Item name={[0]} rules={[formRules.range({ max: 20 })]}>
                                <Input style={{ borderRadius: '0.5rem', width: '80px' }} placeholder='雷' />
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col>
                        <Row gutter={[8, 8]} align='middle' justify='center' style={{ flexDirection: 'column' }}>
                            <Rain className='w-8 h-8' />
                            <Form.Item name={[1]} rules={[formRules.range({ max: 20 })]}>
                                <Input style={{ borderRadius: '0.5rem', width: '80px' }} placeholder='雨' />
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col>
                        <Row gutter={[8, 8]} align='middle' justify='center' style={{ flexDirection: 'column' }}>
                            <Cloud className='w-8 h-8' />
                            <Form.Item name={[2]} rules={[formRules.range({ max: 20 })]}>
                                <Input style={{ borderRadius: '0.5rem', width: '80px' }} placeholder='曇り' />
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col>
                        <Row gutter={[8, 8]} align='middle' justify='center' style={{ flexDirection: 'column' }}>
                            <Sun className='w-8 h-8' />
                            <Form.Item name={[3]} rules={[formRules.range({ max: 20 })]}>
                                <Input style={{ borderRadius: '0.5rem', width: '80px' }} placeholder='晴れ' />
                            </Form.Item>
                        </Row>
                    </Col>
                </Row>
            );
        default:
            return <></>;
    }
};
